import axios from 'axios';
import {backendHost} from '../../config';

export const putPartners = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/partners`, params);
};